module.exports = __webpack_public_path__ + "static/media/BabyCourse_Mobile_10.b2357217.jpf";